import { render, staticRenderFns } from "./smsCurrentTabs.vue?vue&type=template&id=6c0d0dce&"
import script from "./smsCurrentTabs.vue?vue&type=script&lang=ts&"
export * from "./smsCurrentTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports